import * as React from 'react';
import { connect } from 'react-redux';
import { onPageOrSpreadSelect } from '../../../../actions/actions';
import { IPage, ISpread } from '../../../../infrastructure/interfaces';
import { TooltipCont } from '../../../../infrastructure/tooltips';

const mapDispatchToProps = (dispatch: any): any => {
  return {
    selectSpread: (spread: ISpread): void => {
      dispatch(onPageOrSpreadSelect(spread));
    },
    selectPage: (page: IPage): void => {
      dispatch(onPageOrSpreadSelect(page));
    },
  };
};

const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    pages: state.document.pages,
    spreads: state.document.spreads,
    selectedPage: state.editor.selectedPage,
    selectedSpread: state.editor.selectedSpread,
  };
};

export interface SettingNavProps {
  pages?: IPage[];
  spreads?: ISpread[];
  isSpreadView?: boolean;
  selectedPage?: IPage;
  selectedSpread?: ISpread;
  selectPage?(page: IPage): void;
  selectSpread?(spread: ISpread): void;
  className: string;
  showNavButtons: boolean;
}

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class SettingNav extends React.Component<SettingNavProps> {

  getSelectedIndex(): number {

    let selectedIndex: number = 0;
    if (this.props.isSpreadView) {
      if (this.props.selectedSpread == undefined) {
        return selectedIndex;
      }
      selectedIndex = this.props.selectedSpread.id!;
    }

    if (!this.props.isSpreadView) {
      if (this.props.selectedPage == undefined) {
        return selectedIndex;
      }
      selectedIndex = this.props.selectedPage.number - 1
    }

    return selectedIndex;
  }

  incrementPage(incrementAmount: number) {

    const selectedIndex = this.getSelectedIndex();
    const newIndex = Math.max((selectedIndex + incrementAmount), 0);

    if (this.props.isSpreadView) {
      if (this.props.spreads && this.props.selectSpread) {
        this.props.selectSpread(this.props.spreads[newIndex]);
      }
    } else {
      if (this.props.pages && this.props.selectPage) {
        this.props.selectPage(this.props.pages[newIndex]);
      }
    }
  }

  selectNextPage() {
    this.incrementPage(1);
  }

  selectPreviousPage() {
    this.incrementPage(-1);
  }

  render() {
    const selectedPageNumber = this.getSelectedIndex() + 1;

    const { showNavButtons } = this.props;

    const allPages = (this.props.isSpreadView && this.props.spreads) ?
      this.props.spreads.length :
      (this.props.pages ? this.props.pages.length : null);

    const spreadsOrPages = this.props.isSpreadView ? this.props.spreads :
      this.props.pages ? this.props.pages : null;
    const className = this.props.className;

    return (
      (this.props.pages && this.props.pages.length && showNavButtons) ?
        <div className={`page-navigation ${className}`} >
          <button
            title={TooltipCont.PREVIOUS}
            onClick={() => selectedPageNumber !== 1 ? this.selectPreviousPage() : null}
          >
            <i className="fa fa-caret-left" aria-hidden="true" />
          </button>
          <span>
            {`Page ${selectedPageNumber} of ${allPages}`}
          </span>
          <button
            title={TooltipCont.NEXT}
            onClick={() => (spreadsOrPages && (selectedPageNumber !== spreadsOrPages.length)) ? this.selectNextPage() : null}
          >
            <i className="fa fa-caret-right" aria-hidden="true" />
          </button>
        </div > : null
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/common/PageNavigation.tsx